<ng-container *ngIf="{ sessionResponse: sessionResponse$ | async } as streams">
  <div *ngIf="streams.sessionResponse as sessionResponse" class="flex-auto flex-col">
    <ng-container *ngIf="sessionResponse | toCurrentlyLoading">
      <ap-spinner size="2"></ap-spinner>
    </ng-container>
    <ng-container *ngIf="sessionResponse | toLoadedValue as loadedValue">
      <iframe
        apChildId="search-frame"
        class="flex-auto ap-iframe-no-border"
        apIframe
        [url]="loadedValue.value.Url"
      ></iframe>
    </ng-container>
  </div>
</ng-container>

